import { clsx } from 'clsx';

import { ApplicationState, Plan } from '../../Dashboard.types';
import { renderSelectedComponent } from '../../renderSelectedComponent';
import { PaymentPlanCard } from '../PaymentPlanCard/PaymentPlanCard';
import { PlanButton } from '../PlanButton/PlanButton';

export function AccountApplicationSection({
  application,
  selectedPlan,
  selectPaymentPlan,
}: {
  application: ApplicationState;
  selectedPlan: Plan | null;
  selectPaymentPlan: (plan: Plan) => void;
}) {
  return (
    <section
      className={clsx('text-left', { 'mb-xl': !!application })}
      style={{ gridArea: 'application' }}
    >
      {application && (
        <div>
          <h3 className="mt-0">You have an outstanding application</h3>
          <PlanButton
            status={application.status}
            selectedPlanId={selectedPlan?.pay_link_id!}
            selectPaymentPlan={selectPaymentPlan}
            paymentPlan={application}
            renderContent={() => renderSelectedComponent(selectedPlan)}
          >
            <PaymentPlanCard
              created={application.payLink.created}
              reference={application.payLink.reference}
              sellerName={application.payLink.seller_trading_name}
              amount={application.payLink.amount}
              status={application.status}
            />
          </PlanButton>
        </div>
      )}
    </section>
  );
}
